import {
  Box,
  Button,
  Paper,
  SubmitButton,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import React, { useState } from 'react';
import useFormProps from './useFormProps';
import messages from '../messages';
import { FormattedMessage } from 'react-intl';

const TransmissionCard = (props) => {
  const [editState, setEditState] = useState(false);

  const { onSubmit, submitting, reset, ...formProps } = useFormProps({
    editState,
    setEditState,
    updateRentForecast: props.updateRentForecast,
    initialValues: props.initialValues,
  });

  const onCancelClick = () => {
    setEditState(false);
    reset();
  };

  return (
    <Paper
      sx={{
        padding: 3,
        width: 300,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Form {...formProps} />
        <Box display="flex" flexDirection="row-reverse">
          {editState ? (
            <>
              <SubmitButton
                onClick={onSubmit}
                isSubmitting={submitting}
                variant="text"
              >
                <FormattedMessage {...messages.cardSaveLabel} />
              </SubmitButton>
              <Button
                onClick={onCancelClick}
                disabled={submitting}
                sx={{ margin: '0 8px' }}
                variant="text"
              >
                <FormattedMessage {...messages.cardCancelLabel} />
              </Button>
            </>
          ) : (
            <Button
              disabled={props.disabled}
              onClick={() => setEditState(true)}
              variant="text"
            >
              <FormattedMessage {...messages.cardEditLabel} />
            </Button>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default TransmissionCard;
